// Small text utilities shared across pages.
//
// titleCaseName — normalises a name so lowercase/UPPERCASE/mIxEd inputs all
// render as Proper Case. Handles multi-word names, apostrophes and hyphens
// (e.g. O'Neal, Anne-Marie).
export function titleCaseName(raw) {
  if (!raw) return "";
  return raw
    .toLowerCase()
    .split(/(\s+)/)
    .map((tok) =>
      tok.replace(/([a-z\u00C0-\u017F])([a-z\u00C0-\u017F'-]*)/gi, (m, first, rest) => first.toUpperCase() + rest)
    )
    .join("");
}

// razorpayContactFromPhone — returns the raw 10-digit Indian mobile from any
// stored format (`+919876543210`, `919876543210`, `09876543210`, `9876543210`,
// or with whitespace). Non-Indian numbers pass through as E.164 stripped of
// whitespace. Empty string on unparseable input. Purpose: Razorpay Checkout's
// `prefill.contact` reliably prefills only when it receives a bare 10-digit
// Indian mobile — passing `+91...` leaves the field blank on mobile.
export function razorpayContactFromPhone(raw) {
  if (!raw) return "";
  const s = String(raw).replace(/[^\d+]/g, "");
  if (!s) return "";
  // Non-Indian E.164 (e.g. "+15551234567") — pass through
  if (s.startsWith("+") && !s.startsWith("+91")) return s;
  let digits = s;
  if (digits.startsWith("+91")) digits = digits.slice(3);
  else if (digits.startsWith("91") && digits.length === 12) digits = digits.slice(2);
  if (digits.startsWith("0") && digits.length === 11) digits = digits.slice(1);
  if (digits.length === 10 && /^[6-9]/.test(digits)) return digits;
  return "";
}
